export const ru = {
    support_chat: 'чат поддержки',
    support_chat_first_letter_uppercase: 'Чат поддержки',
};
